/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransactionTermsResponse
 */
export interface TransactionTermsResponse {
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    transactionId: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    offerPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    financingType?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    earnestMoneyDeposit?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    closingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    coeDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    titleCompany?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    sellerConcessions?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    buyerAgentCommission?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    ddPeriodDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    appraisalContingency?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    financingContingency?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    inspectionContingency?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    homeWarranty?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    homeWarrantyPaidBy?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    homeWarrantyAmountCents?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    additionalTerms?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    source?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    isCurrent: boolean;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    downPayment?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    acceptanceDeadline?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    appraisalPeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    financingPeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    inspectionPeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    concessionsFlatCents?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    concessionsPercentage?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    buyerAgentCommissionFlatCents?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    buyerAgentCommissionPercentage?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    percentOfListPrice?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    estimatedSellerNet?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    submissionAdditionalTerms?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    clientAdditionalTerms?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    additionalComments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    requestSellerConcessions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    dueDiligenceFee?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    lenderName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    lenderContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    lenderEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    lenderPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    loanId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    preApprovalDocId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    contingencyDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    buyerHomeMlsId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    buyerAgentCommissionSource?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    escalationEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    escalationIncrementCents?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionTermsResponse
     */
    escalationCapCents?: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionTermsResponse
     */
    proposedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionTermsResponse
     */
    onBehalfWithoutClientDecision?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionTermsResponse
     */
    counterComments?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionTermsResponse
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the TransactionTermsResponse interface.
 */
export function instanceOfTransactionTermsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "transactionId" in value;
    isInstance = isInstance && "isCurrent" in value;
    isInstance = isInstance && "escalationEnabled" in value;

    return isInstance;
}

export function TransactionTermsResponseFromJSON(json: any): TransactionTermsResponse {
    return TransactionTermsResponseFromJSONTyped(json, false);
}

export function TransactionTermsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionTermsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'transactionId': json['transaction_id'],
        'offerPrice': !exists(json, 'offer_price') ? undefined : json['offer_price'],
        'financingType': !exists(json, 'financing_type') ? undefined : json['financing_type'],
        'earnestMoneyDeposit': !exists(json, 'earnest_money_deposit') ? undefined : json['earnest_money_deposit'],
        'closingDate': !exists(json, 'closing_date') ? undefined : json['closing_date'],
        'coeDeadline': !exists(json, 'coe_deadline') ? undefined : json['coe_deadline'],
        'titleCompany': !exists(json, 'title_company') ? undefined : json['title_company'],
        'sellerConcessions': !exists(json, 'seller_concessions') ? undefined : json['seller_concessions'],
        'buyerAgentCommission': !exists(json, 'buyer_agent_commission') ? undefined : json['buyer_agent_commission'],
        'ddPeriodDays': !exists(json, 'dd_period_days') ? undefined : json['dd_period_days'],
        'appraisalContingency': !exists(json, 'appraisal_contingency') ? undefined : json['appraisal_contingency'],
        'financingContingency': !exists(json, 'financing_contingency') ? undefined : json['financing_contingency'],
        'inspectionContingency': !exists(json, 'inspection_contingency') ? undefined : json['inspection_contingency'],
        'homeWarranty': !exists(json, 'home_warranty') ? undefined : json['home_warranty'],
        'homeWarrantyPaidBy': !exists(json, 'home_warranty_paid_by') ? undefined : json['home_warranty_paid_by'],
        'homeWarrantyAmountCents': !exists(json, 'home_warranty_amount_cents') ? undefined : json['home_warranty_amount_cents'],
        'additionalTerms': !exists(json, 'additional_terms') ? undefined : json['additional_terms'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'isCurrent': json['is_current'],
        'downPayment': !exists(json, 'down_payment') ? undefined : json['down_payment'],
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : json['acceptance_deadline'],
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : json['appraisal_period_days'],
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : json['financing_period_days'],
        'inspectionPeriodDays': !exists(json, 'inspection_period_days') ? undefined : json['inspection_period_days'],
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : json['concessions_flat_cents'],
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : json['concessions_percentage'],
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : json['buyer_agent_commission_flat_cents'],
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : json['buyer_agent_commission_percentage'],
        'percentOfListPrice': !exists(json, 'percent_of_list_price') ? undefined : json['percent_of_list_price'],
        'estimatedSellerNet': !exists(json, 'estimated_seller_net') ? undefined : json['estimated_seller_net'],
        'submissionAdditionalTerms': !exists(json, 'submission_additional_terms') ? undefined : json['submission_additional_terms'],
        'clientAdditionalTerms': !exists(json, 'client_additional_terms') ? undefined : json['client_additional_terms'],
        'additionalComments': !exists(json, 'additional_comments') ? undefined : json['additional_comments'],
        'requestSellerConcessions': !exists(json, 'request_seller_concessions') ? undefined : json['request_seller_concessions'],
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : json['due_diligence_fee'],
        'lenderName': !exists(json, 'lender_name') ? undefined : json['lender_name'],
        'lenderContactName': !exists(json, 'lender_contact_name') ? undefined : json['lender_contact_name'],
        'lenderEmail': !exists(json, 'lender_email') ? undefined : json['lender_email'],
        'lenderPhone': !exists(json, 'lender_phone') ? undefined : json['lender_phone'],
        'loanId': !exists(json, 'loan_id') ? undefined : json['loan_id'],
        'preApprovalDocId': !exists(json, 'pre_approval_doc_id') ? undefined : json['pre_approval_doc_id'],
        'contingencyDeadline': !exists(json, 'contingency_deadline') ? undefined : json['contingency_deadline'],
        'buyerHomeMlsId': !exists(json, 'buyer_home_mls_id') ? undefined : json['buyer_home_mls_id'],
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : json['buyer_agent_commission_source'],
        'escalationEnabled': json['escalation_enabled'],
        'escalationIncrementCents': !exists(json, 'escalation_increment_cents') ? undefined : json['escalation_increment_cents'],
        'escalationCapCents': !exists(json, 'escalation_cap_cents') ? undefined : json['escalation_cap_cents'],
        'proposedAt': !exists(json, 'proposed_at') ? undefined : (new Date(json['proposed_at'])),
        'onBehalfWithoutClientDecision': !exists(json, 'on_behalf_without_client_decision') ? undefined : json['on_behalf_without_client_decision'],
        'counterComments': !exists(json, 'counter_comments') ? undefined : json['counter_comments'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
    };
}

export function TransactionTermsResponseToJSON(value?: TransactionTermsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'transaction_id': value.transactionId,
        'offer_price': value.offerPrice,
        'financing_type': value.financingType,
        'earnest_money_deposit': value.earnestMoneyDeposit,
        'closing_date': value.closingDate,
        'coe_deadline': value.coeDeadline,
        'title_company': value.titleCompany,
        'seller_concessions': value.sellerConcessions,
        'buyer_agent_commission': value.buyerAgentCommission,
        'dd_period_days': value.ddPeriodDays,
        'appraisal_contingency': value.appraisalContingency,
        'financing_contingency': value.financingContingency,
        'inspection_contingency': value.inspectionContingency,
        'home_warranty': value.homeWarranty,
        'home_warranty_paid_by': value.homeWarrantyPaidBy,
        'home_warranty_amount_cents': value.homeWarrantyAmountCents,
        'additional_terms': value.additionalTerms,
        'source': value.source,
        'is_current': value.isCurrent,
        'down_payment': value.downPayment,
        'acceptance_deadline': value.acceptanceDeadline,
        'appraisal_period_days': value.appraisalPeriodDays,
        'financing_period_days': value.financingPeriodDays,
        'inspection_period_days': value.inspectionPeriodDays,
        'concessions_flat_cents': value.concessionsFlatCents,
        'concessions_percentage': value.concessionsPercentage,
        'buyer_agent_commission_flat_cents': value.buyerAgentCommissionFlatCents,
        'buyer_agent_commission_percentage': value.buyerAgentCommissionPercentage,
        'percent_of_list_price': value.percentOfListPrice,
        'estimated_seller_net': value.estimatedSellerNet,
        'submission_additional_terms': value.submissionAdditionalTerms,
        'client_additional_terms': value.clientAdditionalTerms,
        'additional_comments': value.additionalComments,
        'request_seller_concessions': value.requestSellerConcessions,
        'due_diligence_fee': value.dueDiligenceFee,
        'lender_name': value.lenderName,
        'lender_contact_name': value.lenderContactName,
        'lender_email': value.lenderEmail,
        'lender_phone': value.lenderPhone,
        'loan_id': value.loanId,
        'pre_approval_doc_id': value.preApprovalDocId,
        'contingency_deadline': value.contingencyDeadline,
        'buyer_home_mls_id': value.buyerHomeMlsId,
        'buyer_agent_commission_source': value.buyerAgentCommissionSource,
        'escalation_enabled': value.escalationEnabled,
        'escalation_increment_cents': value.escalationIncrementCents,
        'escalation_cap_cents': value.escalationCapCents,
        'proposed_at': value.proposedAt === undefined ? undefined : (value.proposedAt.toISOString()),
        'on_behalf_without_client_decision': value.onBehalfWithoutClientDecision,
        'counter_comments': value.counterComments,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}

